import DNAButton from "../../../components/controls/DNAButton/DNAButton.theme.alucio";
import DNAText from "../../../components/type/DNAText/DNAText.theme.alucio";
import DNABox from "../../../components/layout/DNABox/DNABox.theme.alucio";
import DNAChip from "../../../components/visual/DNAChip/DNAChip.theme.alucio";
import DNACard from "../../../components/layout/DNACard/DNACard.theme.alucio";
import DNAContextMenu from "../../../components/controls/DNAContextMenu/DNAContextMenu.theme.alucio";
import DNACheckbox from "../../../components/controls/DNACheckbox/DNACheckbox.theme.alucio";
import DNASelect from "../../../components/controls/DNASelect/DNASelect.theme.alucio";
import DNAHeader from "../../../components/layout/DNAHeader/DNAHeader.theme.alucio";
export default {
    strict: {
        ...DNAButton.tokens,
        ...DNAText.tokens,
        ...DNABox.tokens,
        ...DNAChip.tokens,
        ...DNACard.tokens,
        ...DNAContextMenu.tokens,
        ...DNACheckbox.tokens,
        ...DNASelect.tokens,
        ...DNAHeader.tokens,
    },
    components: {
        // Note: we're still levering some styles from the base UI Kitten (hence no DNA prefix)
        Button: DNAButton.theme,
        CheckBox: DNACheckbox.theme,
        Text: DNAText.theme,
        Select: DNASelect.theme,
        DNABox: DNABox.theme,
        DNAChip: DNAChip.theme,
        DNACard: DNACard.theme,
        DNAContextMenu: DNAContextMenu.theme,
        DNAHeader: DNAHeader.theme,
    },
};
//# sourceMappingURL=mappings.js.map